import React from "react";
import clsx from "clsx";
import Assets from "imports/assets.import";
import { ChecklistItemProps } from "interfaces/editor_empty_state.interface";
import "./checklist_item.ui.scss";

const ChecklistItem = (props: ChecklistItemProps) => {
  const { label, icon = Assets.tick_ink, iconAlt = "", className } = props;

  return (
    <div className={clsx("checklist_item", className)}>
      <img className="checklist_item__icon" src={icon} alt={iconAlt} />
      <span className="checklist_item__label">{label}</span>
    </div>
  );
};

export default ChecklistItem;
